var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vip-tip",on:{"click":_vm.handleOpenVip}},[_vm._v(_vm._s(_vm.$t('detailPage.vip.episodes.tip1')))])
}
var staticRenderFns = []

export { render, staticRenderFns }